import { defineComponent } from "vue";
import ScrollAnimation from "@i22/scroll-animation";
import ProductOfferTileMixin from "./component-library258.mjs";
import Heading from "./component-library6.mjs";
import Paragraph from "./component-library5.mjs";
import ProductOfferColorSelect from "./component-library38.mjs";
import ProductOfferShadow from "./component-library259.mjs";
import GridRow from "./component-library28.mjs";
import GridColumn from "./component-library29.mjs";
import Prices from "./component-library32.mjs";
import LinkButton from "./component-library3.mjs";
import { useMappedPropsOptions } from "./component-library152.mjs";
const _sfc_main = defineComponent({
  name: "ProductOfferTileLarge",
  components: {
    LinkButton,
    GridColumn,
    GridRow,
    Heading,
    Paragraph,
    ProductOfferColorSelect,
    ProductOfferShadow,
    Prices
  },
  mixins: [
    ProductOfferTileMixin,
    ScrollAnimation,
    useMappedPropsOptions(Heading, "heading", {
      tag: "h2",
      fontWeight: "ultra"
    })
  ],
  props: {
    offerAlternatives: {
      type: Object,
      required: true
    },
    offerImages: {
      type: Object,
      default: void 0
    },
    showAvailableVariant: {
      type: Boolean
    },
    title: { type: String, default: "" },
    description: { type: String, default: "" },
    backgroundColor: { type: String, default: "light-grey" },
    linkTag: { type: String, default: "a" },
    alignment: {
      type: String,
      default: "left",
      validator(value) {
        return ["left", "right"].includes(value);
      }
    },
    mobileFullWidth: {
      type: Boolean
    },
    ambientImage: {
      type: String,
      default: ""
    },
    animationContent: {
      type: Object,
      default: () => ({
        start: "top bottom",
        end: "top+=15% center",
        vars: { y: 120 }
      })
    },
    animationImage: {
      type: Object,
      default: () => ({
        start: "top bottom",
        end: "top-=15% center",
        vars: { y: 120 }
      })
    },
    preTextWasPrice: { type: String, default: "statt" },
    noColorTitle: { type: Boolean }
  },
  computed: {
    productImageClass() {
      const classes = [`product-offer-tile-large__product-image--${this.backgroundColor}`];
      if (this.showProductImage) {
        classes.push("product-offer-tile-large__product-image--visible");
      }
      return classes.join(" ");
    },
    showProductImage() {
      return !this.isHovered || !this.currentAmbientImage;
    },
    currentAmbientImage() {
      return this.ambientImage;
    },
    ambientImageClass() {
      return !this.showProductImage ? "product-offer-tile-large__ambient-image--visible" : "";
    },
    ambientImageStyle() {
      return `background-image: url(${this.currentAmbientImage})`;
    },
    imageColumnWidthXS() {
      return this.mobileFullWidth ? 12 : 10;
    }
  },
  mounted() {
    setTimeout(this.createScrollAnimations, 1);
  },
  methods: {
    createScrollAnimations() {
      if (this.animationContent && this.$refs.contentRef) {
        this.createScrollTrigger({
          trigger: this.$refs.contentRef.$el,
          start: this.animationContent.start,
          end: this.animationContent.end,
          scrub: 2,
          // @ts-ignore
          animation: this.createTweenFrom(this.$refs.contentRef.$el, this.animationContent.vars)
        });
      }
      if (this.$refs.imageRef && this.animationImageRef) {
        this.createScrollTrigger({
          trigger: this.$refs.imageRef,
          start: this.animationImage.start,
          end: this.animationImage.end,
          scrub: 1,
          // @ts-ignore
          animation: this.createTweenFrom(this.$refs.imageRef, this.animationImage.vars)
        });
      }
    }
  }
});
export {
  _sfc_main as default
};
